import * as React from 'react'
import { useState } from 'react'
import { Button, useNotify, useRefresh, useDataProvider } from 'react-admin'
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout'
import CircularProgress from '@mui/material/CircularProgress'

const ConvertOrderButton = ({ record }) => {
  const [loading, setLoading] = useState(false)
  const notify = useNotify()
  const refresh = useRefresh()
  const dataProvider = useDataProvider()

  const isTargetConvertDateDue = React.useMemo(() => {
    if (!record?.targetConvertDate) return false

    const targetDate = new Date(record.targetConvertDate)
    if (Number.isNaN(targetDate.getTime())) return false

    targetDate.setHours(0, 0, 0, 0)
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    return targetDate <= today
  }, [record?.targetConvertDate])

  // Hide button when already converted or canceled
  if (!record || ['convertedToOrder', 'canceled'].includes(record.requestStatus)) {
    return null
  }

  const handleConvert = async (e) => {
    e.stopPropagation()
    setLoading(true)
    try {
      await dataProvider.create(`kit-requests/${record.id}/convert`, { data: {} })
      notify('Kit request successfully converted to order.', { type: 'success' })
      refresh()
    } catch (err) {
      console.error('Convert kit request error:', err)
      let errorMessage = 'Failed to convert kit request to order.'

      if (err.response.data.message) {
        errorMessage = err.response.data.message
      } else if (err.response.data.error) {
        errorMessage = err.response.data.error
      } else if (err.message) {
        errorMessage = err.message
      }

      notify(errorMessage, { type: 'error', multiLine: true })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      label="Convert to Order"
      onClick={handleConvert}
      disabled={loading}
      variant={isTargetConvertDateDue ? 'contained' : 'outlined'}
      color="primary"
      sx={{ whiteSpace: 'nowrap' }}
    >
      {loading
        ? <CircularProgress size={16} sx={{ mr: 1 }} />
        : <ShoppingCartCheckoutIcon sx={{ mr: 1 }} />
      }
    </Button>
  )
}

export default ConvertOrderButton
